import { WeaTools } from "ecCom";
const getSystemSetTable = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/loadUserMsgConfig",
    "GET",
    params
  );
};
const saveUserConfig = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/saveUserMsgConfig",
    "POST",
    params
  );
};
const getDetailCondition = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/getDetailCondition",
    "POST",
    params
  );
};
const getWorkflowDetailCondition = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/getWorkflowCondition",
    "POST",
    params
  );
};
const getModuleOptions = params => {
  return WeaTools.callApi("/api/msgcenter/homepage/getModule", "GET", params);
};
const saveDetail = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/saveDetailConfig",
    "POST",
    params
  );
};
const saveWorkflowDetail = params => {
  return WeaTools.callApi(
    "/api/msgcenter/config/saveWorkflowDetail",
    "POST",
    params
  );
};
export {
  getSystemSetTable,
  saveUserConfig,
  getDetailCondition,
  getWorkflowDetailCondition,
  getModuleOptions,
  saveDetail,
  saveWorkflowDetail
};



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/apis/systemSetApi.js